// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn--a[data-v-c1b8898c]{font-size:1rem!important;border-bottom:2px solid green}.v-btn--a[data-v-c1b8898c]:before{background-color:transparent!important}", ""]);
// Exports
module.exports = exports;
